import { CategoryIcon } from "@commerce-frontend/ui/base/CategoryIcon/CategoryIcon";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { countryOf, flagPath } from "@commerce-shared/utility";
import Image from "next/image";

type Props = {
	label: string;
	icon?: string | null;
	trigger?: () => void;
	flagCountry?: string;
	showChevron?: boolean;
};

export const MenuItemTrigger = ({
	label,
	icon,
	trigger,
	flagCountry,
	showChevron = true,
}: Props) => (
	<button
		type="button"
		onClick={() => {
			trigger && trigger();
		}}
		className="flex w-full items-center justify-between rounded-none border-b border-border py-4"
	>
		<div className="flex items-center gap-2 text-sm text-blue-300">
			{icon && (
				<CategoryIcon iconName={icon} iconSize="24" className="bg-main" />
			)}

			{flagCountry && (
				<Image
					className="size-6 rounded-full border border-gray-100 object-cover"
					src={flagPath(flagCountry)}
					width="24"
					height="24"
					alt={`flag of ${countryOf(flagCountry)}`}
					unoptimized
				/>
			)}

			{label}
		</div>
		{showChevron && <Icon icon="chevron-right" className="size-6 bg-main" />}
	</button>
);
